const resourceColors: Record<string, string> = {
  auth: '#6366f1', aluno: '#10b981', escola: '#3b82f6', turma: '#8b5cf6',
  chamada: '#f59e0b', professor: '#14b8a6', default: '#64748b',
};
const acaoLabel: Record<string, string> = {
  VIEW: 'Visualizou', CREATE: 'Criou', UPDATE: 'Atualizou', DELETE: 'Deletou',
  PATCH: 'Alterou', LOGIN_SUCCESS: 'Login realizado', LOGIN_FAILED: 'Login falhou',
  LOGOUT: 'Logout', SECURITY_BLOCK: 'Bloqueio de segurança',
};

function Field({ label, value }: { label: string; value?: string | null }) {
  if (!value) return null;
  return (
    <div style={{ marginBottom: 10 }}>
      <div style={{ fontSize: '.68rem', fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', marginBottom: 2 }}>{label}</div>
      <div style={{ fontSize: '.82rem', color: '#1e293b', fontWeight: 500, wordBreak: 'break-all' }}>{value}</div>
    </div>
  );
}

interface AuditDetailPanelProps {
  log: any;
  onClose: () => void;
}

export function AuditDetailPanel({ log, onClose }: AuditDetailPanelProps) {
  const det = log.detalhes as Record<string, any> | null;
  const nomeUsuario = log.usuario?.nome || 'Sistema';
  const perfilUsuario = log.usuario?.cargo || log.usuario?.perfil || log.perfilUsuario || 'Sistema';
  const escolaNome = log.usuario?.escola?.nome || null;
  const fotoUrl = log.usuario?.fotoUrl;
  const inicial = nomeUsuario.charAt(0).toUpperCase();
  const dotColor = resourceColors[log.recurso] || resourceColors.default;
  const acaoTraduzida = acaoLabel[log.acao] || log.acao;
  const criadoEm = new Date(log.criadoEm).toLocaleString('pt-BR');

  return (
    <div style={{ flex: '0 0 44%', marginLeft: 12, padding: '14px 16px', background: '#f8fafc', borderRadius: 12, border: '1px solid #e2e8f0', overflowY: 'auto', maxHeight: 480, position: 'relative' }}>
      <button onClick={onClose} style={{ position: 'absolute', top: 10, right: 10, background: 'none', border: 'none', cursor: 'pointer', color: '#94a3b8', padding: 4 }}>✕</button>
      <div style={{ fontSize: '.8rem', fontWeight: 800, color: '#6366f1', marginBottom: 12, display: 'flex', alignItems: 'center', gap: 6 }}>
        <div style={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: dotColor }} />
        Detalhe do Evento
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', background: 'white', borderRadius: 8, border: '1px solid #e2e8f0', marginBottom: 14 }}>
        {fotoUrl ? (
          <img src={fotoUrl} alt={nomeUsuario} style={{ width: 38, height: 38, borderRadius: '50%', objectFit: 'cover', border: '2px solid #c7d2fe', flexShrink: 0 }} />
        ) : (
          <div style={{ width: 38, height: 38, borderRadius: '50%', backgroundColor: '#6366f115', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#6366f1', fontSize: '1rem', fontWeight: 800, border: '1px solid #c7d2fe', flexShrink: 0 }}>{inicial}</div>
        )}
        <div>
          <div style={{ fontWeight: 700, color: '#0f172a', fontSize: '.88rem' }}>{nomeUsuario}</div>
          <div style={{ fontSize: '.75rem', color: '#64748b' }}>{perfilUsuario}</div>
          {log.usuario?.email && <div style={{ fontSize: '.72rem', color: '#94a3b8' }}>{log.usuario.email}</div>}
        </div>
      </div>
      <Field label="Ação" value={`${acaoTraduzida} (${log.acao})`} />
      <Field label="Recurso" value={log.recurso} />
      <Field label="ID do Recurso" value={log.recursoId} />
      <Field label="Escola Operada" value={escolaNome} />
      <Field label="Data / Hora" value={criadoEm} />
      <Field label="IP de Origem" value={log.ip} />
      <Field label="Status HTTP" value={log.statusCode ? String(log.statusCode) : null} />
      <Field label="Duração" value={log.duracao ? `${log.duracao} ms` : null} />
      <Field label="Município" value={log.municipio} />
      <Field label="UF" value={log.uf} />
      {det && Object.keys(det).length > 0 && (
        <div>
          <div style={{ fontSize: '.68rem', fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', marginBottom: 6 }}>Contexto Adicional</div>
          <div style={{ background: 'white', borderRadius: 6, border: '1px solid #e2e8f0', padding: '8px 10px', display: 'flex', flexDirection: 'column', gap: 4 }}>
            {Object.entries(det).map(([k, v]) => (
              <div key={k} style={{ display: 'flex', gap: 6, fontSize: '.76rem' }}>
                <span style={{ color: '#94a3b8', fontWeight: 600, minWidth: 60 }}>{k}</span>
                <span style={{ color: '#334155', wordBreak: 'break-all' }}>{String(v)}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
